jQuery(document).ready(function($){

	intiBgImg();
	initCollapse();
	initMobileNav();
	initCarousel();
	initUniform();
	initPie();
    initVideoPlayer();
	initFixedScrollBlock();
    initValidate();
    initLeadership();
    initSticky();

});

jQuery(window).on('load', function($){
	initCustomMap();
	initIsotope();
	initAnchors();
});

function initSticky() {
    var breadcrumbs = $('.breadcrumb-container, .top-breadcrumb'),
        nav = $('#header:not(.nav-devices-page)'),
        lastScrollTop = $(window).scrollTop();

    if (nav.length){
        $(window).scroll(function (e) {
            var scrollTop = $(window).scrollTop(),
                navHeight = nav.outerHeight();
            if (breadcrumbs.length){
                var breadcrumbsTop = $(breadcrumbs).position().top;
                if (scrollTop > breadcrumbsTop){
                    breadcrumbs.addClass('sticky');
                } else {
                    breadcrumbs.removeClass('sticky');
                }
            }
            if (lastScrollTop > scrollTop){
                nav.removeClass('hidden-header');
                nav.addClass('sticky');
                nav.addClass('transition');
            } else {
                if(scrollTop > navHeight){
                    nav.addClass('hidden-header');
                    nav.removeClass('sticky');
                }
            }
            if (scrollTop == 0){
                nav.removeClass('hidden-header');
                nav.removeClass('sticky');
                nav.removeClass('transition');
            }

            lastScrollTop = scrollTop;

        });
    }
}

function initLeadership() {
    if ( jQuery(window).width() < 768 ){
        var root = jQuery('.leadership .grid-inline'),
            itemHeight = root.find('li').first().outerHeight();

            root.each(function () {
                var el = jQuery(this);
                el.css({
                    'maxHeight': itemHeight
                });
            });

        jQuery('.show-leadership').on('click', function (e) {
            e.preventDefault();
            var el = jQuery(this),
                parent = el.parent(),
                grid = parent.find('.grid-inline');
            grid.css({
                'maxHeight' : '3500px'
            });
            el.css({
                'display':'none'
            })
        });
    }
};

function initValidate() {
    var validator = $('form.contact-form').validate({
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $('.contact-form').addClass(errorClass).removeClass(validClass);

            var error_ = $(element).attr('data-error');

            $(element).tooltip({
                'title' : error_
            }).tooltip('show');

        },
        submitHandler: function(form) {

            $('.contact-form input[type=submit]').html('Sending <span class="glyphicon glyphicon-refresh"></span>');

            var url = $(form).attr('action');
            var params = $(form).serialize();
            $.ajax ({
                type: 'POST',
                url: url,
                data: params,
                success: function(response) {
                    if(response.status == 'success'){
                        $('.server-text').fadeOut();
                        $(form).fadeOut(function(){
                            $('.thank-text').fadeIn();
                        });
                    }else{
                        $('.contact-form .btn-contact').html('Submit');
                        $('.server-text').fadeIn();
                    }
                }
            });

            return false;
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            if (validator.numberOfInvalids() == 0){
                $('.contact-form').removeClass(errorClass).addClass(validClass);
            }
            $(element).tooltip('destroy');
        },
        rules: {
            'first_name': {
                required: true
            },
            'last_name':{
                required: true
            },
            'email': {
                required: true,
                email: true
            },
            'type': {
                required: true
            },
            'message': {
                required: true
            },
            'robot': {
                required: true
            }
        },
        messages: {
            'first_name'	: "Please specify your First Name",
            'last_name'	: "Please specify your Last Name",
            'type'          : "Please specify field",
            'message'		: "Please enter your Message",
            'robot'		    : "Are you robot?",
            'email'			: {
                required: "We need your email address to contact you",
                email: "Your email address must be in the format of name@domain.com"
            }
        }

    });
}

function initVideoPlayer() {
    jQuery('.video-player').each(function () {
        var el = jQuery(this),
            btn = el.find('.btn-play'),
            video = el.find('video'),
            videoEl = video[0];
        btn.on('click', function (e) {
            e.preventDefault();
            if (videoEl.paused == true) {
                videoEl.play();
                el.addClass('played')
            } else {
                videoEl.pause();
                el.removeClass('played')
            }
        });
    });
};

// custom map init
function initCustomMap() {
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	jQuery('.map-hold').each(function() {
        var mapHolder = jQuery(this),
            overlay = jQuery('<div class="map-overlay"/>')
		mapHolder.data('CustomMap', new CustomMap({
			holder: this,
			defaultOptions: {
				maxZoom: 18,
				zoom: 4,
				draggable: !isTouchDevice,
				scrollwheel: true,
				disableDefaultUI: true
			}
		}));

        mapHolder.append(overlay);

        jQuery('.map-hold').on('mouseenter', '.map-overlay', function (e) {
            setTimeout(function () {
                jQuery('.map-hold .map-overlay').css({'display':'none'});
            }, 1000);
        });

	});
}

function intiBgImg() {
	jQuery('.bg-cover').each(function() {
		var holder = jQuery(this),
            parent = holder.parent(),
		    image = holder.find('> img').hide(),
		    imageSrc = image.prop('src');
        if (!parent.hasClass("bg-video-cover") || $(window).width()<768){
            holder.css({
                backgroundImage: 'url(' + imageSrc + ')'
            });
        }
	});
}

// collpase
function initCollapse() {
	jQuery('.js-collapse li').each(function(){
		var holder = jQuery(this);
		var opener = holder.find('.js-opener');
		var slide = holder.find('.js-slide').hide();

		opener.click(function(){
			slide.slideToggle();
			holder.toggleClass('active');
			return false;
		});

		if (holder.hasClass('active')) {
			slide.show();
		}
	});
}

// uniform forms
function initUniform(){
	jQuery(":radio").uniform({radioClass: 'nice-radio'});
	jQuery(":checkbox").uniform({checkboxClass: 'nice-checkbox'});
	jQuery("select").uniform({selectClass: 'nice-select', selectAutoWidth : false});
}

// mobile menu init
function initMobileNav() {
	jQuery('.search-wrap').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'search-active',
		menuOpener: '.search-opener',
		menuDrop: '.drop'
	});
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		menuDrop: '#nav'
	});
}

// initialize fixed blocks on scroll
function initFixedScrollBlock() {
	jQuery('#wrapper').fixedScrollBlock({
		slideBlock: '.nav-devices',
		positionType: 'fixed'
	});
}

// scroll gallery init
function initCarousel() {
	jQuery('.carousel:not(#home-carousel)').slick({
		infinite: true,
		arrows: true,
		draggable: false,
		dots: true,
		fade: true,
		cssEase: 'linear',
		prevArrow: '<a href="#" class="slick-prev"></a>',
		nextArrow: '<a href="#" class="slick-next"></a>'
	});

    jQuery('#home-carousel').on('init', function () {
        var vid = $('#home-carousel .video-first'),
            video_bg = vid[0];
        if (vid.length){
            if (video_bg.paused){
                vid[0].play();
            }
        }

    });

    jQuery('#home-carousel').slick({
        infinite: true,
        arrows: true,
        pauseOnFocus: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 7000,
        draggable: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        prevArrow: '<a href="#" class="slick-prev"></a>',
        nextArrow: '<a href="#" class="slick-next"></a>'
    });


    jQuery('#home-carousel').on('afterChange', function (slick, currentSlide) {
        var cur = $(currentSlide.$slides[currentSlide.currentSlide]);
        if(cur.hasClass('bg-video-cover')){
            var vid = cur.find('.bgvid-hidden'),
                video_bg = vid[0];
            if (vid.length){

                    vid[0].play();

            }
        }

        var video = $('.oct-video').find('video').get(0).play();

    });
}

// Isotopes
function initIsotope() {
	jQuery('.isotope-grid').isotope({
		itemSelector: "li",
		masonry: {
			gutter: 0
		}
	});
}

// initialize smooth anchor links
function initAnchors() {
	new SmoothScroll({
		anchorLinks: '.nav-devices a[href^="#"]:not([href="#"])',
		extraOffset: function() {
			var totalHeight = 0;
			jQuery('.nav-devices').each(function(){
				totalHeight += jQuery(this).outerHeight();
			});
			return totalHeight;
		},
		activeClasses: 'link'
	});

    initAnchorActive($);

}

// piechart
function initPie() {
  var circleColor = '#f5c400';
  var circleBG = '#f5c300';

	jQuery('.circle-progress').circleProgress({
		startAngle: -Math.PI / 4 * 2,
		size: 111,
		thickness: 9,
		fill: {
			color: circleColor
		}
	}).on('circle-animation-progress', function(event, progress, stepValue) {
		jQuery(this).find('.val').text(String(parseInt(stepValue.toFixed(2)*100)) + '%');
	});

	jQuery('.circle-progress-a').circleProgress({
		startAngle: -Math.PI / 4 * 2,
		size: 141,
		thickness: 25,
		//emptyFill: '#f5c300',
		emptyFill: '#ffffff',
		fill: {
			color: circleColor
		}
	}).on('circle-animation-progress', function(event, progress, stepValue) {
		jQuery(this).find('.val').text(String(parseInt(stepValue.toFixed(2)*100)) + '%');
	});


	jQuery('.circle-progress-b').circleProgress({
		startAngle: -Math.PI / 4 * 2,
		size: 165,
		thickness: 8,
		emptyFill: '#303031',
		fill: {
			color: circleColor
		}
	}).on('circle-animation-progress', function(event, progress, stepValue) {
		jQuery(this).find('.val').text((stepValue*60).toFixed(2) + ' Min');
	});

}

function initAnchorActive($) {

    if( $('.nav-devices ul li:last-of-type a').hasClass('anchor-active') ) {
        $('.nav-devices ul li:nth-child(4)').addClass('anchor-active');
    } else {
        $('.nav-devices ul li:nth-child(4)').removeClass('anchor-active');
    }

    $(window).scroll(function() {

        if( $('.nav-devices ul li:last-of-type a').hasClass('anchor-active') ) {
            $('.nav-devices ul li:nth-child(4)').addClass('anchor-active');
        } else {
            $('.nav-devices ul li:nth-child(4)').removeClass('anchor-active');
        }

    });

}